<template>
  <div>
    <p class="text-sm text-center">
      Coloque seu email abaixo que nós iremos enviar um link para você redefinir
      sua senha.
    </p>

    <form v-on:submit.prevent ref="formContainer">
      <label for="login">Email</label>
      <input v-model="email" id="login" type="email" class="mb-6" />

      <button
        @click="handleSendEmail"
        :class="{ loading: isLoading }"
        class="mt-5 button button-primary"
      >
        <i v-if="isLoading" class="material-icons mr-2">
          sync
        </i>
        Redefinir Senha
      </button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      validationErrors: "",
      isLoading: false
    };
  },

  methods: {
    handleSendEmail() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;

      this.validationErrors = "";
      const email = this.email;

      this.$store
        .dispatch("sendResetEmail", { email })

        .then(() => {
          this.validationErrors = "";
          this.isLoading = false;

          this.$emit("validationErrors", this.validationErrors);

          this.$toasted.success(
            `Ótimo! Seu email foi enviado. Agora é só seguir as instruções`,
            { icon: "done_outline" }
          );
        })
        .catch(error => {
          this.isLoading = false;

          this.$toasted.error(`Ops... ${error.response.data.message}`);
          if (error.response.status === 422) {
            this.validationErrors = error.response.data.errors;
            this.$emit("validationErrors", this.validationErrors);
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.loading {
  background-color: lightgray;
}
i {
  animation-name: spin;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
